import { ChangeDetectionStrategy, Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ICategories, IGroupers } from '../../../../private/shared/models/productos';

@Component({
  selector: 'getm-categories-and-subcategories',
  templateUrl: './categories-and-subcategories.component.html',
  styleUrls: ['./categories-and-subcategories.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoriesAndSubcategoriesComponent  implements OnInit {

  @Input() categorias: ICategories[] = [];
  @Input() agrupadores: IGroupers[] = [];

  @Output() selectCategory = new EventEmitter<string | null>();
  @Output() selectGrouper = new EventEmitter<string | null>();
  
  public agrupadoresFiltered: IGroupers[] = [];
  public activeCategory: string | null = null;
  public activeAgrupador: string | null = null;

  constructor() { }

  ngOnInit() {}

  public onCategorySelect(categoryId: string | null) {
    this.activeAgrupador = null;
    if (this.activeCategory === categoryId) {
      this.activeCategory = null;
      this.agrupadoresFiltered = [];
      this.selectCategory.emit(null);
      return;
    }
    this.activeCategory = categoryId;
    this.agrupadoresFiltered = this.agrupadores.filter(ag => ag.ID_Categoria_GETM === categoryId);
    this.selectCategory.emit(categoryId);
  }

  public onAgrupadorSelect(agrupadorId: string | null) {
    if (this.activeAgrupador === agrupadorId) {
      this.activeAgrupador = null;
      this.selectGrouper.emit(null);
      return;
    }
    this.activeAgrupador = agrupadorId;
    this.selectGrouper.emit(agrupadorId);
  }

}
